import CollapseItem from "@/components/elements/Collapse";

export default function RulesComponents2(){
    return(
        <>
            <h2>2. 個人や企業への不当な批判や中傷する内容</h2>
            <ul>
                <CollapseItem title="個人や企業への不当な批判や中傷する内容" eventKey="rule2-1">
                    <p><b>個人や企業への不当な批判や中傷は禁止です。</b>これは、悪口や根拠のないデマを含む発言、
                    名誉や人格を傷つける内容を指します。誹謗中傷は悪意の有無にかかわらず、他者を傷つける可能性があるため、言動には十分な注意が求められます。</p>
                    <p style={{ margin:"15px" }}><i className="fa-solid fa-message-exclamation fa-fw fa-lg fa-flip-horizontal"></i> <b>誹謗中傷には「誹謗（相手の悪口）」と「中傷（根拠のない発言で相手を傷つけること）」が含まれます。
                    批判は、異なる意見を表明する行為ですが、誹謗中傷は虚偽や悪意を伴う発言です。</b></p>
                    <p><b>具体例:</b></p>
                    <ol>
                        <li>企業に対する誹謗中傷の例<b>（禁止される例）</b>:</li>
                        <p>「○○ゲーム会社の社員は全員無能だ。まともなゲーム一つ作れない。」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>これは、根拠のない侮辱的な表現で、企業全体を攻撃しています。</b></p>
                        <p>「○○ゲーム会社はユーザーを騙しているだけで、まともなゲームを出したことがない。」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>根拠のない批判であり、悪意を持った名誉棄損に該当します。</b></p>
                        <li>企業に対する批判の例<b>（許容される例）</b>:</li>
                        <p>「○○ゲーム会社の新作はバグが多く、プレイが困難だ。次回作ではもっとテストをしてほしい。」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>具体的な問題点を指摘し、改善を求めている批判です。</b></p>
                        <p>「○○ゲーム会社のサポートは遅く、問題解決までに時間がかかるため、改善が必要だと思う。」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>事実に基づいた意見で、侮辱的な表現がなく、許容される批判です。</b></p>
                        <li>個人に対する誹謗中傷の例<b>（禁止される例）</b>:</li>
                        <p>「このWIKIの管理人は無能で、何をやっても失敗する。」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>管理人に対する根拠のない侮辱で、名誉を傷つけています。</b></p>
                        <li>個人に対する批判の例<b>（許容される例）</b>:</li>
                        <p>「このWIKIの管理人の対応は遅いと感じる。もっと迅速に対応してほしい。」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>個人の対応に対する改善を求める意見で、攻撃的な表現が含まれていません。</b></p>
                        <p>「名前は長い方が有利は最低だ。荒らし行為ばっかしているし」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>これは、名前は長い方が有利を攻撃しており、これは利用規約で義務となっています。</b></p>
                        <li>ゲームプレイヤーに対する誹謗中傷の例<b>（禁止される例）</b>:</li>
                        <p>「このゲームのプレイヤーはすごいよな。無能なキャラクター相手に遊んでる時点でお察しだよな。」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>プレイヤーを侮辱し、「無能なキャラクター」と関連付けて攻撃しています。
                        これは特定の集団に対する誹謗中傷です。</b></p>
                        <li>ゲームプレイヤーに対する批判の例<b>（許容される例）</b>:</li>
                        <p>「このゲームのプレイヤーは戦略をもう少し工夫するべきだと思う。今のやり方では勝つのが難しい。」<br/>
                        <b><i className="fa-solid fa-arrow-turn-down-right fa-fw"></i>プレイヤーのプレイスタイルに対する改善を提案している批判で、
                        攻撃的な表現がなく、許容されます。</b></p>
                    </ol>
                </CollapseItem>
                <CollapseItem title="執拗に要求する行為" eventKey="rule2-2">
                    <p><b>他者や運営に対して執拗に要求する行為は禁止です。</b>これは、相手に過度な要求や同じ要求を繰り返し行うことで、
                    精神的な負担や不快感を与える行為を指します。運営へのお問い合わせでも、同じ要求を何度も繰り返すことが含まれます。</p>
                    <p style={{ margin:"15px" }}><i className="fa-solid fa-message-exclamation fa-fw fa-lg fa-flip-horizontal"></i> <b>他のユーザーや運営が明確に回答や拒否をしたにもかかわらず、
                    同じ内容をしつこく要求し続ける行為は、威力業務妨害などにも該当する可能性があります。</b></p>
                    <p><b>具体例:</b></p>
                    <ol>
                        <li>拒否された後にさらに要求</li>
                        <p>運営や管理者に対して、一度断られたリクエストを繰り返し送る行為。例えば、拒否された削除依頼を何度も送り続ける。</p>
                        <li>同じ質問を複数のチャネルで送る</li>
                        <p>メールやフォーラム、SNSなど、異なる手段を使って同じ要求をし続け、相手に圧力をかける。</p>
                        <li>管理者にしつこく依頼</li>
                        <p>管理者に対して、「〇〇を規制してくれ」と繰り返し求め、拒否されても再度要求する行為。</p>
                    </ol>
                </CollapseItem>
                <CollapseItem title="シーライオニング行為" eventKey="rule2-3">
                    <p><b>シーライオニング行為は禁止されています。</b>これは、礼儀正しさを装って、相手に執拗に質問や反論を繰り返し、相手を精神的に疲弊させる行為です。
                    WIKIの管理者に対して頻繁に行われることがあり、管理者はボランティアとして活動しているため、こうした行為は大きな負担となります。</p>
                    <p style={{ margin:"15px" }}><i className="fa-solid fa-message-exclamation fa-fw fa-lg fa-flip-horizontal"></i> <b>管理者や他の利用者を困らせる行為は、迷惑行為として禁止されています。
                    健全なコミュニケーションを心がけましょう。</b></p>
                </CollapseItem>
            </ul>
        </>
    )
}